<ng-template #sidenavRef>
  <nx-ratenow-ui-sidenav [collapsed]="(sidenavCollapsed$ | async) === true"></nx-ratenow-ui-sidenav>
</ng-template>

<ng-template #toolbarRef>
  <nx-ratenow-toolbar
    [hasShadow]="toolbarShadowEnabled$ | async"
    [mobileQuery]="(isDesktop$ | async) === false"
    class="ratenow-toolbar"
  ></nx-ratenow-toolbar>
</ng-template>

<ng-template #quickpanelRef>
  <nx-ratenow-ui-quickpanel></nx-ratenow-ui-quickpanel>
</ng-template>

<nx-ratenow-ui-layaout [quickpanelRef]="quickpanelRef" [sidenavRef]="sidenavRef" [toolbarRef]="toolbarRef"></nx-ratenow-ui-layaout>
